/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage} from '../modules/auth/'
import {App} from '../App'
import OtpCode from "../modules/auth/components/Otp-code/Otp-code";
import DashboardWrapper from "../pages/dashboard/DashboardWrapper";
import {useSelector} from "react-redux";
import {selectUser} from "../../redux/slices/login-slice";
import {PrivateRoutes} from "./PrivateRoutes";


/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */

const AppRoutes: FC = () => {
    const items: any = useSelector(selectUser);

    return (
        <BrowserRouter>
            <Routes>
                <Route element={<App/>}>
                    <Route path='error/*' element={<ErrorsPage/>}/>
                    <Route path='auth/*' element={<AuthPage/>}/>
                    <Route path='*' element={<Navigate to='/auth'/>}/>
                    {items.username ? (
                        <>
                            <Route path='/*' element={<PrivateRoutes/>} />
                            <Route path='/dashboard' element={<DashboardWrapper/>}/>
                            <Route path='/otp_code' element={<OtpCode/>}/>
                        </>
                    ) : (
                        <>
                            <Route path='auth/*' element={<AuthPage />} />
                            <Route path='*' element={<Navigate to='/auth' />} />
                        </>
                    )}
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export {AppRoutes}


//   {currentUser ? (
//             <>
//               <Route path='/*' element={<PrivateRoutes />} />
//               <Route index element={<Navigate to='/dashboard' />} />
//             </>
//           ) : (
//             <>
//               <Route path='auth/*' element={<AuthPage />} />
//               <Route path='*' element={<Navigate to='/auth' />} />
//             </>
//           )}